import isObject from 'lodash/isObject';
import { isNotEmptyString } from '../is-not-empty-string';
export var validateSetOptionsVisibilityRule = function validateSetOptionsVisibilityRule(optionsVisibility) {
  return isObject(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every(isNotEmptyString);
};